import * as constants from '@/utils/templates/databaseTemplate/database.constants';
import * as types from '@/components/Database/database.types';
import i18n from '@/plugins/i18n';

export const getDBMNavTabs = () => [
  {
    activeTab: 'MY',
    tabs: [
      {
        key: constants.SUB_TYPES.MY_INSTANCE,
        label: i18n.global.t('dbm.database-hardware'),
      },
      {
        key: constants.SUB_TYPES.MY_QUERYPERFORMANCE,
        label: i18n.global.t('dbm.queryperformanceTab'),
      },
      {
        key: constants.SUB_TYPES.MY_CONNECTIONS,
        label: i18n.global.t('dbm.connectionsTab'),
      },
      {
        key: constants.SUB_TYPES.MY_METRICS,
        label: i18n.global.t('dbm.metricsTab'),
      },
    ],
  },
  {
    activeTab: 'MS',
    tabs: [
      {
        key: 'ms-hardware',
        label: i18n.global.t('dbm.hardwareTab'),
      },
      {
        key: 'ms-processes',
        label: i18n.global.t('processes'),
      },
      {
        key: 'ms-query-performance',
        label: i18n.global.t('dbm.queryperformanceTab'),
      },
      {
        key: 'ms-connections',
        label: i18n.global.t('dbm.connection'),
      },
      {
        key: 'ms-metrics',
        label: i18n.global.t('metrics'),
      },
    ],
  },
  {
    activeTab: types.DatabaseTypes.cb,
    tabs: [
      {
        key: constants.SUB_TYPES.CB_CLUSTER,
        label: i18n.global.t('dbm.cluster-overview'),
      },
      {
        key: constants.SUB_TYPES.CB_NODE,
        label: i18n.global.t('k8.node'),
      },
      {
        key: constants.SUB_TYPES.CB_QUERIES,
        label: i18n.global.t('dbm.queries'),
      },
      {
        key: constants.SUB_TYPES.CB_BUCKET,
        label: i18n.global.t('alert.bucket'),
      },
    ],
  },
  {
    activeTab: 'ES',
    tabs: [
      { key: 'es-cluster', label: i18n.global.t('alert.cluster') },
      {
        key: 'es-node',
        label: i18n.global.t('alert.node'),
      },
    ],
  },
  {
    activeTab: 'OR',
    tabs: [
      {
        key: constants.SUB_TYPES.ORA_INSTANCE,
        label: i18n.global.t('dbm.hardwareTab'),
      },
      {
        key: constants.SUB_TYPES.ORA_QUERYPERFORMANCE,
        label: i18n.global.t('dbm.queryperformanceTab'),
      },
      {
        key: constants.SUB_TYPES.ORA_CONNECTIONS,
        label: i18n.global.t('dbm.connectionsTab'),
      },
      {
        key: constants.SUB_TYPES.ORA_METRICS,
        label: i18n.global.t('dbm.metricsTab'),
      },
    ],
  },
  {
    activeTab: 'PG',
    tabs: [
      {
        key: constants.SUB_TYPES.POS_INSTANCE,
        label: i18n.global.t('dbm.hardwareTab'),
      },
      {
        key: constants.SUB_TYPES.PS_QUERYPERFORMANCE,
        label: i18n.global.t('dbm.queryperformanceTab'),
      },
      {
        key: constants.SUB_TYPES.PS_CONNECTIONS,
        label: i18n.global.t('dbm.connectionsTab'),
      },
      {
        key: constants.SUB_TYPES.PS_METRICS,
        label: i18n.global.t('dbm.metricsTab'),
      },
    ],
  },
  {
    activeTab: types.DatabaseTypes.ca,
    tabs: [
      {
        key: constants.SUB_TYPES.CAS_INSTANCE,
        label: i18n.global.t('dbm.hardwareTab'),
      },
      {
        key: constants.SUB_TYPES.CAS_QUERYPERFORMANCE,
        label: i18n.global.t('dbm.queryperformanceTab'),
      },
      {
        key: constants.SUB_TYPES.CAS_CONNECTIONS,
        label: i18n.global.t('dbm.connectionsTab'),
      },
      {
        key: constants.SUB_TYPES.CAS_METRICS,
        label: i18n.global.t('dbm.metricsTab'),
      },
    ],
  },
  {
    activeTab: types.DatabaseTypes.mg,
    tabs: [
      {
        key: constants.SUB_TYPES.MONGO_HARDWARE,
        label: i18n.global.t('dbm.hardwareTab'),
      },
      {
        key: constants.SUB_TYPES.MONGO_QUERYPERFORMANCE,
        label: i18n.global.t('dbm.queryperformanceTab'),
      },
      {
        key: constants.SUB_TYPES.MONGO_RESOURCE,
        label: i18n.global.t('dbm.resourceTab'),
      },
      {
        key: constants.SUB_TYPES.MONGO_PERFORMANCE,
        label: i18n.global.t('dbm.performanceTab'),
      },
      {
        key: constants.SUB_TYPES.MONGO_CONNECTIONS,
        label: i18n.global.t('dbm.connectionsTab'),
      },
      {
        key: constants.SUB_TYPES.MONGO_METRICS,
        label: i18n.global.t('dbm.metricsTab'),
      },
    ],
  },
];

const database = {
  key: 'database',
  name: i18n.global.t('databaseMonitoring'),
  icon: 'database',
  navTabs: getDBMNavTabs(),
};
export default database;
